import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Spin, message } from "antd";
// import AmCharts from "@amcharts/amcharts3-react";
import { LoadingOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const LiraHorizontalBarGraph = (props) => {
  if (props.divId === "mtdData") {
    
  }
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chart = useRef(null);

  useEffect(() => {
    let x = am4core.create(props.divId, am4charts.XYChart);
    if (props.data) {
      // x.dateFormatter.inputDateFormat = "yyyy-MM-dd";
      x.data = props.data;
      if (props.legend.enable === true) {
        x.legend = new am4charts.Legend();
        x.legend.position = props.legend.position;
        x.legend.labels.template.fill = am4core.color(props.legend.color);
      }
      x.padding =props.chartDiv.padding; //Top,Right,Bottom/Left

      //title
      if (props.title.enable === true) {
        var title = x.titles.create();
        title.text = props.title.val;
        title.fontSize = props.title.fontSize;
        title.marginTop = 0;
        title.marginBottom = 0;
        title.fontWeight = 600;
        title.fill = props.title.color;
      }

      // Create axes
      // if (props.valueLabels.enable === true){
      // var dateAxis = x.xAxes.push(new am4charts.DateAxis());
      var valueAxis = x.xAxes.push(new am4charts.ValueAxis());

      valueAxis.renderer.labels.template.fontSize = props.valueLabel.fontSize;
      valueAxis.renderer.labels.template.fill = props.valueLabel.color;
     
      if (props.chartDiv.grid.gridHorizontal === true) {
        valueAxis.renderer.line.strokeOpacity = 0.2;
        valueAxis.renderer.line.strokeWidth = 1;
        valueAxis.renderer.line.stroke = am4core.color(
          props.chartDiv.grid.gridColor
        );
        valueAxis.renderer.grid.template.stroke = props.chartDiv.gridColor;
      } else {
        valueAxis.renderer.grid.template.strokeWidth = 0;
        }

      if (props.valueAxis.enable === false) {
        valueAxis.renderer.labels.template.disabled = true;
      }

      var categoryAxis = x.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = props._id;
      categoryAxis.renderer.minGridDistance = 15;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.grid.template.stroke = props.chartDiv.gridColor;

      categoryAxis.renderer.labels.template.fontSize =
        props.categoryAxis.fontSize;
      categoryAxis.renderer.labels.template.fill = props.categoryAxis.color;
      if (props.chartDiv.grid.gridVertical === true) {
      categoryAxis.renderer.line.strokeOpacity = 0.2;
      categoryAxis.renderer.line.strokeWidth = 1;
      categoryAxis.renderer.line.stroke = props.chartDiv.gridColor;}else{
      categoryAxis.renderer.grid.template.strokeWidth = 0;}
      // categoryAxis.renderer.label.dx = props.valueLabel.dx;
      // categoryAxis.renderer.label.dy = props.valueLabel.dy;
      // categoryAxis.renderer.line.stroke = am4core.color("#ecf0f1");
      // categoryAxis.renderer.labels.template.adapter.add(
      //   "dy",
      //   function (dy, target) {
      //     if (target.dataItem && target.dataItem.index & (2 == 2)) {
      //       return dy + 25;
      //     }
      //     return dy;
      //   }
      // );

      // let valueLabel = x.series.bullets.push(new am4charts.LabelBullet());
      // valueLabel.label.text = "Hello";
      // valueLabel.label.fontSize = 10;

      /* Create series */
      let columnSeries = x.series.push(new am4charts.ColumnSeries());
      columnSeries.xAxis = valueAxis;
      columnSeries.dataFields.valueX = props.columnSeries.columnSeriesvalueX;
      columnSeries.dataFields.categoryY = props._id;
      columnSeries.name = props.columnSeries.name;
      columnSeries.columns.template.width = am4core.percent(
        props.columnSeries.columnWidth
      );
      columnSeries.columns.template.clickable = true;
      columnSeries.columns.template.tooltipText =
        "{categoryY}: [bold]{valueY}[/]";
      columnSeries.columns.template.fillOpacity = 0.8;
      columnSeries.columns.template.strokeOpacity = 0;

      x.colors.list = [
        am4core.color(props.columnSeries.color[0]),
        am4core.color(props.columnSeries.color[1]),
        am4core.color(props.columnSeries.color[2]),
        am4core.color(props.columnSeries.color[3]),
        am4core.color(props.columnSeries.color[4]),
        am4core.color(props.columnSeries.color[5]),
        am4core.color(props.columnSeries.color[6]),
        am4core.color(props.columnSeries.color[7]),
        am4core.color(props.columnSeries.color[8]),
        am4core.color(props.columnSeries.color[9]),
      ];

      columnSeries.columns.template.adapter.add("fill", (fill, target) => {
        return target.dataItem
          ? x.colors.getIndex(target.dataItem.index)
          : fill;
      });
      columnSeries.columns.template.column.cornerRadiusTopLeft =
        props.columnSeries.cornerRadius[0];
      columnSeries.columns.template.column.cornerRadiusTopRight =
        props.columnSeries.cornerRadius[1];
      columnSeries.columns.template.column.cornerRadiusBottomLeft =
        props.columnSeries.cornerRadius[2];
      columnSeries.columns.template.column.cornerRadiusBottomRight =
        props.columnSeries.cornerRadius[3];
      columnSeries.columns.template.events.on(
        "hit",
        function (ev) {
          // if (props.onChange) {
          //   props.onChange({
          //     _id: ev.target.dataItem.categories.categoryY,
          //     value: ev.target.dataItem.values.valueY.value
          //   });
          // }
        },
        this
      );
      if (props.columnSeries.shadow === true) {
        var shadow = columnSeries.filters.push(new am4core.DropShadowFilter());
        shadow.dx = 20;
        shadow.dy = 20;
        shadow.blur = 5;
        chart.current = x;
      }

      if (props.valueLabel.enable === true) {
        var valueLabel = columnSeries.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.color = props.valueLabel.color;
        valueLabel.label.text = props.valueLabel.val;
        valueLabel.label.fontSize = props.valueLabel.fontSize;
        valueLabel.label.verticalCenter = props.valueLabel.verticalCenter;
        valueLabel.label.horizontalCenter = props.valueLabel.horizontalCenter;
        valueLabel.label.dx = props.valueLabel.dx;
        valueLabel.label.dy = props.valueLabel.dy;
      }

      categoryAxis.events.on("sizechanged", function (ev) {
        var axis = ev.target;
        // var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
        if (props.categoryAxis.orientation === "ang") {
          axis.renderer.labels.template.rotation = -45;
          axis.renderer.labels.template.horizontalCenter = "right";
          axis.renderer.labels.template.verticalCenter = "middle";
        } else if (props.categoryAxis.orientation === "hor") {
          axis.renderer.labels.template.rotation = 0;
          axis.renderer.labels.template.horizontalCenter = "middle";
          axis.renderer.labels.template.verticalCenter = "middle";
        } else if (props.categoryAxis.orientation === "ver") {
          axis.renderer.labels.template.rotation = -90;
          axis.renderer.labels.template.horizontalCenter = "middle";
          axis.renderer.labels.template.verticalCenter = "top";
        }
      });
      var categoryAxis = categoryAxis.renderer.labels.template;
      if (props.categoryAxis.wrap === true) {
        categoryAxis.wrap = true;
        categoryAxis.maxWidth = props.categoryAxis.wrapMaxWidth;
      }

      // if (props.lineSeries1.enable === true) {
      //   let lineSeries1 = x.series.push(new am4charts.LineSeries());
      //   lineSeries1.name = props.lineSeries1.name;
      //   lineSeries1.dataFields.valueY = props.lineSeries1.lineSeriesvalueY;
      //   lineSeries1.dataFields.categoryY = props._id;
      //   lineSeries1.stroke = am4core.color(props.lineSeries1.lineColor);
      //   lineSeries1.strokeWidth = props.lineSeries1.lineStrokeWidth;
        
      //   if (props.lineSeries1.smoothenCurve === true) {
      //     lineSeries1.tensionX = 0.8;
      //     lineSeries1.tensionY = 0.8;
      //   }
      //   chart.current = x;
      //   if (props.lineSeries1.shadow === true) {
      //     var shadow = lineSeries1.filters.push(new am4core.DropShadowFilter());
      //     shadow.dx = 5;
      //     shadow.dy = 5;
      //     shadow.blur = 3;
      //     chart.current = x;
      //   }
      // }

      // if (props.lineSeries2.enable === true) {
      //   let lineSeries2 = x.series.push(new am4charts.LineSeries());
      //   lineSeries2.name = props.lineSeries2.name;
      //   lineSeries2.dataFields.valueY = props.lineSeries2.lineSeriesvalueY;
      //   lineSeries2.dataFields.categoryY = props._id;
      //   lineSeries2.stroke = am4core.color(props.lineSeries2.lineColor);
      //   lineSeries2.strokeWidth = props.lineSeries2.lineStrokeWidth;
      //   if (props.lineSeries2.smoothenCurve === true) {
      //     lineSeries2.tensionX = 0.8;
      //     lineSeries2.tensionY = 0.8;
      //   }
      //   chart.current = x;
      //   if (props.lineSeries2.shadow === true) {
      //     var shadow = lineSeries2.filters.push(new am4core.DropShadowFilter());
      //     shadow.dx = 5;
      //     shadow.dy = 5;
      //     shadow.blur = 3;
      //     chart.current = x;
      //   }
      // }
    }
    return () => {
      x.dispose();
    };
  });

  return (
    <div>
      {props.data ? (
        <div
          id={props.divId}
          style={{
            width: props.chartDiv.width,
            height: props.chartDiv.height,
            borderRadius: props.chartDiv.borderRadius,
            padding: "0px",
            marginLeft: "10px",
            marginTop: "0px",

            background: props.chartDiv.background,
            // boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
            // borderRadius: "10px",
            // background: "rgb(106,106,111)",
            // backgroundImage:
            //   "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,1) 57%, rgba(33,32,40,1) 100%)",
            //   border: "2px solid #6a6a6f"
          }}
        ></div>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
  );
};

export default LiraHorizontalBarGraph;
